//The Privacy view navigation modal

import React from 'react';
import MobileNavigationModal from './MobileNavigationModal';
import { SmartNavigationDrawer } from './SmartNavigationDrawer';
import { InjectedFormProps } from 'redux-form';
import NavigationDrawer from './NavigationDrawer';

export const MobileNavigationPrivacy: React.FC<InjectedFormProps> = (props) => {
  return (
    <MobileNavigationModal {...props}>
      <NavigationDrawer
        variant={'privacy'}
        isAdmin={true}
        rootUrl={'/legal/policies/'}
      />
    </MobileNavigationModal>
  );
};
